import React from "react";
import { Box, TextField, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Grid } from '@mui/material';
const SaveForm = ({
  agendaDateTime,
  setAgendaDateTime,
  observacion,
  setObservation,
  handleSave,
  isSaving,
  theme,
  searchFlag,
  isPromesa,
  onFechaPromesa,
  onMontoPromesa
}) => {
  return (
 
<Box display="flex" justifyContent="center" mt={2} width="100%">
  <Grid container spacing={2}>
  {isPromesa &&(
      <>
        <Grid item xs={12} md={6}>
          <TextField
            id="date"
            label="Fecha Promesa"
            type="date"
            fullWidth
            onChange={(event) => {
              const newValue = event.target.value === "" ? null : event.target.value;
              onFechaPromesa(newValue);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              type="number"
              label="MontoPromesa"
              onChange={(event) => {
                const newValue = event.target.value === "" ? null : event.target.value;
                onMontoPromesa(newValue);
              }}
            />
      </Grid>
    </>
    )}
    <Grid item xs={12} md={6}>
      <TextField
          id="datetime-local"
          label="Fecha y hora de agenda"
          type="datetime-local"
          fullWidth
          onBlur={(event) => event.target.blur()}
          onChange={(event) => {
            const newValue = event.target.value === "" ? null : event.target.value;
            setAgendaDateTime(newValue);
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
    </Grid>
    
    <Grid item xs={12} >
      <TextField
        label="Observación"
        multiline
        fullWidth
        value={observacion}
        onChange={(e) => setObservation(e.target.value)}
      />
    </Grid>
    

    <Grid item xs={12} md={12}>

    <Button
          onClick={handleSave}
          disabled={isSaving}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            "&:hover": { backgroundColor: theme.palette.primary.dark },
          }}
        >
          {isSaving ? "Gestion Guardada" : "Guardar"}
        </Button>
    </Grid>

  </Grid>
</Box> 


  );
};

export default SaveForm;
